import * as React from "react";
import { memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M16 22h2a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v2.85" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 2v5a1 1 0 0 0 1 1h5M8 14v2.2l1.6 1" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 16,
			r: 6
		})
	]
});
const Memo = memo(SvgFileClock);
export default Memo;
